import { PeriodType } from '../types';

export function getPeriodLabel(periodType: PeriodType): string {
  if (periodType === 'dayCal') return 'Last 30 Days';
  if (periodType === 'weekCal') return 'Last 12 Weeks';
  if (periodType === 'quarterCal') return 'Last 4 Quarters';
  return 'Last 12 Months';
}
